<template>
    <div>
        <!-- <button @click="test">test</button> -->
    <li ref="itemRef">
        <!-- <div
            :class="{bold: isFolder}"
        > -->
        <div>
            <span v-if="isFolder" @click="toggle" :class="[isOpen ? 'arrow-down' : 'arrow-right']" :title="isOpen ? $t('CollapseTheList') : $t('ExpandTheList')">{{ isOpen ? '&#x25BC;' : '&#10148;' }}</span>
            <span @click="SetSelectItem" :class="['text',isSelect ? 'underline' : '']">{{ getName }} </span>
        </div>
        <ul v-show="isOpen" v-if="isFolder">
            <tree-item
                v-for="(child, index) in item.children"
                :key="index"
                :item="child"
                :selectHashTag="selectHashTag"
                @select-item="$emit('select-item', $event)"
                @open-folder="openFoldef"
            ></tree-item>
        </ul>
    </li>
    </div>
</template>

<script>
    import { mapGetters} from 'vuex';

    export default {
        name: "TreeItem",
        props: {
            item: Object,
            selectHashTag: String
        },
        data() {
            return {
                isOpen: false,
            };
        },
        computed: {
           isFolder() {
                return this.item.children && this.item.children.length;
            },
            getName() {
                if (!this.item.locales || this.currentLng()=='en') {
                    return this.item.name
                }
                let local = this.item.locales.find(l=>l.language = this.currentLng());
                return local ? local.name : this.item.name;
            },
            isSelect() {
                let res = this.item.hashTag == this.selectHashTag
                if(res) this.$emit("open-folder");
                return res;
            }
        },
        methods: {
            ...mapGetters(['currentLng']),
            test() {
                // console.log((this.selectItem && (this.selectItem.hashTag == this.item.hashTag)));
                console.log(this.currentLng());
            },
            toggle() {
                if (this.isFolder) {
                this.isOpen = !this.isOpen;
                }
            },
            SetSelectItem() {
                this.$emit("select-item", this.item);
            },
            openFoldef() {
                if(this.isFolder) this.isOpen = true;
                this.$emit("open-folder");

            }
        }
    }
</script>

<style scoped>
    .underline {
        text-decoration: underline;
        text-decoration-color: #dd0000;
    }
    ul {
        padding-left: 1em;
        line-height: 1.5em;
        list-style-type: dot;
    }
    li {
        list-style-type: none;
    }
    .arrow-right {
        color: #dd0000;
        margin-left: -16px;
        cursor: pointer;
    }
    .arrow-down {
        color: #dd0000;
        margin-left: -14px;
        cursor: pointer;
    }
    .text {
        color: #dd0000;
        cursor: pointer;
    }
</style>